window.jQuery = window.$ = $
